// third party libarrys
import { useLazyQuery, useMutation, useQuery } from "@apollo/client";
import _ from "lodash";
import React, { useEffect, useState } from "react";
import useReactRouter from "use-react-router";
import {
  // Tab,
  // Tabs,
  Modal,
  Spinner,
  Alert,
  Container,
  // ButtonGroup
} from "react-bootstrap";
import { errorFields } from "../../../helpers/sweetalert";

// components
import { CREATE_ORDER_CONFIRM_WIDTH_PAYMENT } from "../../../graphql/order/mutation";
import { GET_USER_CONFIRMS } from "../../../graphql/userConfirm/query";
import useWindowDimensions from "../../../helpers/useWindowDimensions";
import { GET_EXCHANGRATE } from "../../../graphql/exchangeRate/Query";
import {
  CREATE_USER_CONFIRM,
  ENSURE_USER_CONFIRM_BY_PHONE,
} from "../../../graphql/userConfirm/mutation";
import { GET_PAYMENT_TAXE } from "../../../graphql/partner/query";
import { BG_GRADIENT_NEW, COLOR_WHITE } from "../../../constants";
import {
  calcOrderTotal,
  convertPriceWithCommission,
  formatDeliveryAddress,
  imageRender,
  numberFormat,
} from "../../../helpers";
import { GET_ORDERGROUPS_DETAIL } from "../../../graphql/order/query";
import OrderGroupDetail from "./OrderGroupDetail";
import ShopInfoOrderConfirm from "./ShopInfoOrderConfirm";
import FinishOrder from "./FinishOrder";
// import { GET_BANKS } from "../../../graphql/bank/query";
import {
  GET_SETTINGS,
  GET_SETTING_BY_SHOP,
} from "../../../graphql/setting/query";

// images
import lailaoPaymentIcon from "../../../image/lailao_payment_icon.png";
import ListReceiveAddress from "../../settings/settingLogictics/settingReceive/ListReceiveAddress";
import ReceiveDeliveryAddress from "../../settings/settingLogictics/settingReceive/CardDefaultReceiveAddress";
import { GET_USER_ADDRESS_BY_PHONE } from "../../../graphql/userConfirm/userAddress/query";
import FormReceiveAddress from "../../settings/settingLogictics/settingReceive/FormReceiveAddress";
import AddressSheet from "./AddressSheet";
import FindAddressByPhone from "./FindAddressByPhone";
import {
  FaCheckCircle,
  FaFacebook,
  FaMapMarkerAlt,
  FaPhoneAlt,
} from "react-icons/fa";
import { ADD_ORDER_DELIVERY } from "../../../graphql/orderDelivery/mutation";
import ConfirmCOD from "./ConfirmCOD";
import LoadingAbsolute from "../../../components/loading/LoadingAbsolute";
// import ConfirmPaymentAuto from "./confirm_payment_auto";

function MultiStepForm({ onPaymentStateChange }) {
  const { history, match, location } = useReactRouter();

  // State
  const { width, height } = useWindowDimensions();
  const [orderData, setOrderData] = useState();
  const [firsStep, setFirstStep] = useState(true);
  const [secondStep, setSecondStep] = useState(false);
  const [lastStep, setLastStep] = useState(false);
  const [customerName, setCustomerName] = useState("");
  const [address, setAddress] = useState("");
  const [phone, setPhone] = useState("");
  // ເບີໂທຮັບ 7-11 ໂຕເລກ (ຄືກັບ ShopInfoOrderConfirm) ຄຳນວນບ່ອນດຽວ ຢ່າຂຽນຊ້ຳໃນ JSX
  const isPhoneValid = phone?.length >= 7 && phone?.length <= 11;
  const isPhoneInvalid = !!phone && !isPhoneValid;
  const [isAlert, setIsAlert] = useState(false);
  const [shopId, setShopId] = useState();
  const [shopRate, setShopRate] = useState();
  const [paymentSupports, setPaymentSupports] = useState({
    partner: "",
  });
  const [taxPrice, setTaxPrice] = useState(0);
  const [showPreview, setShowPreview] = useState(false);
  const [qrCodeUrl, setQrCodeUrl] = useState();

  //! FIND ADDRESS BY PHONE (ແທນລະບົບ PIN ເກົ່າ)
  const [idDataUserConfirm, setIdDataUserConfirm] = useState({});
  const [phoneAddresses, setPhoneAddresses] = useState([]);
  const [lookupPhone, setLookupPhone] = useState("");

  //! RECEIVE ADDRESS
  const [isReceiveData, setIsReceiveData] = useState({});
  const [isAddModal, setIsAddModal] = useState(false);
  const onCloseModalAdd = () => setIsAddModal(false);
  // ກົດ card "ພິມທີ່ຢູ່ເອງ" ໃນໜ້າເພີ່ມທີ່ຢູ່ — ປິດໜ້ານັ້ນ ແລ້ວກັບມາພິມຢູ່ໜ້ານີ້
  // (ແບບດຽວກັບ ShopInfoOrderConfirm — ຝັ່ງ payment gateway ເຄີຍບໍ່ມີທາງພິມເອງເລີຍ)
  const onUseManualAddress = () => {
    setIsUseLogicstics("NOT_USE_LOGICSTIC");
    setIsAddModal(false);
  };
  // ຂົນສົ່ງບໍ່ໄດ້ຖືກເລືອກຢູ່ໜ້ານີ້ອີກແລ້ວ — ມັນມາພ້ອມທີ່ຢູ່ທີ່ລູກຄ້າເລືອກ
  // `selectedDelivery` ຍັງເກັບໄວ້ເປັນຄ່າວ່າງ ເພື່ອບໍ່ໃຫ້ລາຍການທີ່ຢູ່ຖືກກອງເຫຼືອເຈົ້າດຽວ
  const selectedDelivery = "";
  // logic ເກົ່າຂອງ ຂົນສົ່ງອື່ນໆ: ເລີ່ມທີ່ໂໝດພິມທີ່ຢູ່ເອງກ່ອນ (prefill ຈາກ userConfirm ຫຼ້າສຸດ)
  // ຂົນສົ່ງໃນລະບົບເປັນທາງເລືອກ ສະເພາະຮ້ານທີ່ເປີດ isUseLogistics ເທົ່ານັ້ນ
  const [isUseLogicstics, setIsUseLogicstics] = useState("NOT_USE_LOGICSTIC");
  const [isShipMentPaytype, setIsShipMentPayType] = useState({
    isOpenCod: false,
    data: null,
  });

  const [userAddressByPhone_API] = useLazyQuery(GET_USER_ADDRESS_BY_PHONE, {
    fetchPolicy: "network-only",
  });

  useEffect(() => {
    if (!_.isEmpty(isReceiveData)) {
      setCustomerName(isReceiveData?.userName);
      setAddress(formatDeliveryAddress(isReceiveData));
      setPhone(isReceiveData?.userTel);
    }
  }, [isReceiveData]);

  // ດຶງລາຍການໃໝ່ຫຼັງລູກຄ້າເພີ່ມທີ່ຢູ່ ເພື່ອໃຫ້ທີ່ຢູ່ທີ່ຫາກໍ່ບັນທຶກຂຶ້ນມາທັນທີ
  const refetchAddressByPhone = async (phoneFromForm) => {
    try {
      const _phone = phoneFromForm || lookupPhone;
      if (_phone?.length !== 8) return;
      setLookupPhone(_phone);
      const res = await userAddressByPhone_API({
        variables: { where: { userTel: _phone } },
      });
      setPhoneAddresses(res?.data?.userAddressByPhone?.data ?? []);
      const _userId = res?.data?.userAddressByPhone?.userId;
      if (_userId) setIdDataUserConfirm({ id: _userId, phone: _phone });
    } catch (err) {
      console.log("ERROR_refetchAddressByPhone");
    }
  };

  // ຜົນຄົ້ນຫາຈາກຊ່ອງເບີໂທ: ເລືອກທີ່ຢູ່ໃໝ່ສຸດໃຫ້ເລີຍ ລູກຄ້າກົດຕໍ່ໄປໄດ້ໂດຍບໍ່ຕ້ອງເລືອກຫຍັງ
  const onFoundAddressByPhone = ({ phone: foundPhone, userId, addresses }) => {
    setLookupPhone(foundPhone);
    setPhoneAddresses(addresses);
    // ເກັບເບີໄວ້ເຖິງຍັງບໍ່ມີບັນຊີ ຟອມຈະໄດ້ prefill ແລະ ສ້າງບັນຊີເອງຕອນບັນທຶກ
    setIdDataUserConfirm(
      userId ? { id: userId, phone: foundPhone } : { phone: foundPhone },
    );
    setIsReceiveData(addresses[0] ?? {});
  };

  // addUserAddress ບັງຄັບຕ້ອງມີ user id — ລູກຄ້າໃໝ່ຈຶ່ງຕ້ອງສ້າງບັນຊີ (ບໍ່ມີ PIN) ກ່ອນເປີດຟອມ
  const [ensureUserConfirmByPhone_API] = useMutation(
    ENSURE_USER_CONFIRM_BY_PHONE,
  );
  const onOpenAddAddress = async () => {
    try {
      if (!idDataUserConfirm?.id && lookupPhone?.length === 8) {
        const res = await ensureUserConfirmByPhone_API({
          variables: { phone: lookupPhone },
        });
        const user = res?.data?.ensureUserConfirmByPhone;
        if (user?.id) setIdDataUserConfirm({ id: user.id, phone: lookupPhone });
      }
      setIsAddModal(true);
    } catch (err) {
      errorFields({ text: "ບໍ່ສາມາດເພີ່ມທີ່ຢູ່ໄດ້ ກະລຸນາລອງໃໝ່" });
    }
  };

  //! ADD_USER_ADDRESS
  const [addOrderDelivery_API, { loading: addOrderDeliveryLoading }] =
    useMutation(ADD_ORDER_DELIVERY);
  const addOrderDeliveryWeb = async () => {
    try {
      const newAddOrderDelivery_API = await addOrderDelivery_API({
        variables: {
          data: {
            shipment_pay_type:
              orderData?.orders[0]?.stock?.shipment_pay_type ?? "CDC",
            latLong: isReceiveData?.latLong,
            sender: isReceiveData?.sender,
          },
          where: {
            delivery: isReceiveData?.deliveryName,
            orderGroupId: orderData?.id,
            userAddressId: isReceiveData?.id,
            shop: orderData?.shop?.id,
          },
        },
      });
      if (
        newAddOrderDelivery_API?.data?.addOrderDelivery?.message !== "Success"
      )
        throw newAddOrderDelivery_API?.data?.addOrderDelivery?.message;
      return { isError: false };
    } catch (err) {
      errorFields({ text: "ສ້າງຂົນສົ່ງບໍ່ສຳເລັດ" });
      console.log("ERROR_addOrderDeliveryWeb");
      return { isError: true };
    }
  };

  const { data: paymentTaxDatas } = useQuery(GET_PAYMENT_TAXE);
  // const [getBankData, { data: bankData, loadingBank }] = useLazyQuery(GET_BANKS, {
  //   fetchPolicy: "cache-and-network",
  // });
  const [getShopSetting, { data: shopSettingData, loadingSetting }] =
    useLazyQuery(GET_SETTINGS, { fetchPolicy: "cache-and-network" });
  const [getOrderData, { data: _orderData, loading: _orderLoading }] =
    useLazyQuery(GET_ORDERGROUPS_DETAIL, { fetchPolicy: "network-only" });

  const [confirmOrderGroups, { loading: loadingConfirmOrder }] = useMutation(
    CREATE_ORDER_CONFIRM_WIDTH_PAYMENT,
  );

  const [getUserConfirms, { data: userConfirmDatas }] =
    useLazyQuery(GET_USER_CONFIRMS);
  const [getExchangeRate, { data: loadExchangeRate, loadingExchange }] =
    useLazyQuery(GET_EXCHANGRATE, { fetchPolicy: "cache-and-network" });
  // setting by shop
  const { data: settingData, refetch: fetchSettingData } = useQuery(
    GET_SETTING_BY_SHOP,
    {
      fetchPolicy: "network-only",
      variables: {
        where: {
          shop: shopId,
        },
      },
    },
  );

  const [createUserConfirm] = useMutation(CREATE_USER_CONFIRM);

  const pathname = location?.pathname;
  const _orderId = pathname.split("/").pop();

  useEffect(() => {
    getExchangeRate({
      variables: {
        where: {
          shop: shopId,
        },
      },
    });
  }, [shopId]);

  useEffect(() => {
    if (match?.params?.data) {
      let matchData = match?.params?.data.split("&&");
      getLiveOrder(matchData[0], matchData[1]);
      fetchSettingData();
    }
  }, [match?.params?.data]);

  // ກວດສອບເງື່ອນໄຂການນຳໃຊ້ຟັງຊັ່ນ
  useEffect(() => {
    if (paymentTaxDatas || settingData) {
      // ຖ້ານຳໃຊ້ payment gateway ຈຶ່ງເກັບຄ່າ fee
      if (settingData?.settingByShopId?.isPaymentGateway) {
        setTaxPrice(
          paymentTaxDatas?.paymentSupportCurrencyLAKTax?.data?.taxPrice,
        );
      }
      // ຖ້ານຳໃຊ້ ຂົນສົ່ງ ຈຶ່ງສະແດງ ຂົນສົ່ງ
      // if(settingData?.settingByShopId?.isUseLogicstics) {
      //   setIsUseLogicstics("NOT_USE_LOGICSTIC")
      // }
    }
  }, [paymentTaxDatas, settingData]);

  useEffect(() => {
    if (!_.isEmpty(_orderData?.orderGroup)) {
      _fetchShopSetting(_orderData?.orderGroup?.shop?.id);
      // _fetchBank(_orderData?.orderGroup?.shop?.id);
      setOrderData(_orderData?.orderGroup);
      // header ຢູ່ຄົນລະ component — ສົ່ງສະຖານະຂຶ້ນໄປໃຫ້ມັນຮູ້ວ່າຄວນກະພິບເຕືອນບໍ່
      if (onPaymentStateChange)
        onPaymentStateChange(!!_orderData?.orderGroup?.isPaymented);
      setCustomerName(
        _orderData?.orderGroup?.cfName || _orderData?.orderGroup?.customerName,
      );
      setAddress(
        `${_orderData?.orderGroup?.logistic || ""} ${_orderData?.orderGroup?.addressCf || ""}`,
      );
      setPhone(_orderData?.orderGroup?.phone);
      setShopId(_orderData?.orderGroup?.shop?.id);
    }
    if (_orderData?.orderGroup?.phone && _orderData?.orderGroup?.paySlip) {
      setSecondStep(true);
      setLastStep(true);
    }
  }, [_orderData]);

  // get user confirm
  useEffect(() => {
    if (orderData && !_.isEmpty(orderData.userFbId)) {
      getUserConfirms({
        variables: {
          where: {
            psid: orderData?.userFbId,
          },
          orderBy: "createdAt_DESC",
        },
      });
    }
  }, [orderData]);

  useEffect(() => {
    if (userConfirmDatas?.userConfirms?.data) {
      // const customerJsonData = localStorage.getItem('CUSTOMER_DATA');
      // let customerData = {};
      // if (customerJsonData) {
      //   customerData = JSON.parse(customerJsonData)
      // }
      setPhone(userConfirmDatas?.userConfirms?.data[0]?.phone);
      setAddress(userConfirmDatas?.userConfirms?.data[0]?.addressCF);
    }
  }, [userConfirmDatas]);

  useEffect(() => {
    if (loadExchangeRate?.exchangeRate) {
      setShopRate(loadExchangeRate?.exchangeRate);
    }
  }, [loadExchangeRate]);

  const getLiveOrder = async (_liveId, _userFbId) => {
    try {
      getOrderData({
        variables: {
          where: {
            // live: _liveId,
            // cfName: _userFbId,
            // userFbId: _userFbId,
            id: _liveId,
            // isDeleted: false
          },
          orderBy: "createdAt_DESC",
        },
      });
    } catch (error) {
      console.log("Error retrieving posts", error);
    }
  };

  const _fetchShopSetting = async (shopId) => {
    getShopSetting({
      variables: {
        where: { shop: shopId },
        orderBy: "createdAt_ASC",
      },
    });
  };

  // const _fetchBank = async (shopId) => {
  //   try {
  //     getBankData({
  //       variables: {
  //         where: {
  //           shop: shopId,
  //           isDeleted: false,
  //         },
  //         skip: 0,
  //         limit: 100,
  //         orderBy: "createdAt_DESC",
  //       },
  //     });
  //   } catch (err) {
  //     console.log(err);
  //   }
  // };

  const onConfirmForClient = async () => {
    try {
      if (!phone || !address) {
        setIsAlert(true);
        return;
      }

      if (loadingConfirmOrder) return;

      //! RECEIVE
      //
      // ບຸກຄິງຂົນສົ່ງລົ້ມເຫຼວ ຕ້ອງບໍ່ຍົກເລີກການຢືນຢັນການຊຳລະ.
      //
      // ກ່ອນນີ້ບ່ອນນີ້ throw "ERROR_CREATE_DELIVERY" ເຊິ່ງເຮັດໃຫ້ confirmOrderGroups()
      // ຂ້າງລຸ່ມບໍ່ຖືກເອີ້ນເລີຍ — ລູກຄ້າຈຶ່ງບໍ່ໄດ້ຮັບຂໍ້ຄວາມ "ຮັບຍອດແລ້ວ" ແລະ ບໍ່ມີ log
      // ອອກມາເລີຍ ເພາະ resolver ບໍ່ເຄີຍເຣັນ.
      //
      // In production this fired as SORRY_SHOP_DELIVERY: JNT_IS_TURN_OFF — 181 of the 182
      // shops with a carrier enabled have jntIsOpen=false, so forcing the J&T booking
      // silently killed the confirmation message for almost every shop.
      //
      // The customer has already paid. Whether the shop could book a waybill is a
      // shop-side concern and must never decide whether the customer is told their
      // payment was received. Record it, warn, and carry on to the confirmation.
      let _deliveryFailed = false;
      if (isUseLogicstics === "IS_USE_LOGICSTIC") {
        const newAddOrderDelivery = await addOrderDeliveryWeb();
        _deliveryFailed = !!(
          newAddOrderDelivery && newAddOrderDelivery.isError
        );
        if (_deliveryFailed)
          console.log("DELIVERY_BOOKING_FAILED_CONTINUING_TO_CONFIRM");
      }

      // let get_taxPrice = localStorage.getItem("TAX_PRICE");
      // let _taxPrice = parseInt(get_taxPrice);
      // setIsAlert(false);

      // let priceToPaid = await calculateRoundedValue(priceProduct / 1000) * 1000;
      let priceToPaid = convertPriceWithCommission(
        orderData?.totalPrice,
        orderData?.sumPriceBaht,
        orderData?.sumPriceUsd,
        taxPrice,
        shopRate,
      );

      // create user confirm
      await createUserConfirm({
        variables: {
          data: {
            name: customerName,
            phone: phone,
            addressCF: address,
            psid: orderData?.userFbId,
            shop: orderData?.shop?.id,
          },
        },
      }).catch((err) => console.log(err));

      let newDta = {
        // amount: priceToPaid,
        // amount: 1,
        shopName: orderData?.shop?.name,
        shop: orderData?.shop?.id,
        phone: phone,
        addressCf: address,
        customerName: customerName,
      };
      let newWhere = {
        orderGroupId: orderData?.id,
        shop: orderData?.shop?.id,
      };
      if (
        orderData?.sumPriceBaht > 0 ||
        (orderData?.sumPriceUsd > 0 && shopRate)
      ) {
        newWhere = { ...newWhere, rate: JSON.stringify(shopRate) };
      }

      // update and confirm orderGroup
      const response = await confirmOrderGroups({
        variables: {
          data: newDta,
          where: newWhere,
        },
      });

      if (response) {
        setShowPreview(true);
        let _response = JSON.parse(response?.data?.createPaymentOrder?.data);
        let link = JSON.parse(_response?.data).redirectURL;
        setQrCodeUrl(link);
      }
    } catch (error) {
      console.log({ error });
      errorFields({ text: "ເກີດຂໍ້ຜິດພາດ ກະລຸນາລອງໃໝ່ພາຍຫຼັງ" });
      setIsAlert(false);
    }
  };

  // on selelct mode of payment
  const onModePayment = async (e) => {
    if (e === "MANUAL_PAYMENT") {
      setTaxPrice(0);
      setPaymentSupports({
        partner: null,
        // // on selelct mode of payment
        // const onModePayment = async (e) => {
        //   if (e === "MANUAL_PAYMENT") {
        //     setTaxPrice(0)
        //     setPaymentSupports({
        //       partner: null
        //     })
        //   } else {
      });
    } else {
      let _taxPrice = localStorage.getItem("TAX_PRICE");
      if (settingData?.settingByShopId?.isPaymentGateway) {
        setTaxPrice(parseInt(_taxPrice));
      }
      setPaymentSupports({
        partner: "LAILAO_PAYMENT_SUPPORT",
      });
    }
  };

  // onclose modal confirm cod for customer
  const handleCloseCodModal = () => {
    setIsShipMentPayType({
      isOpenCod: false,
      data: null,
    });
  };

  if (
    _orderLoading ||
    loadingSetting ||
    loadingExchange ||
    addOrderDeliveryLoading
  )
    return <LoadingAbsolute />;

  return (
    <>
      {/* {!shopSettingData?.isPaymentGateway ? 
      <div
        style={{ textAlign: "center" }}>
        <p>ກະລຸນະຕັ້ງຄ່າໃຫ້ຄົບຖ້ວນ(ເພີ່ມບັນຊີທະນາຄານ ຫລື ນຳໃຊ້ Payment gateway)</p>
        <p>ແລ້ວຮີເຟສເພື່ອລອງໃຫມ່ອີກຄັ້ງ</p>
        <p>ລາຍລະອຽດເພີ່ມເຕີ່ມ ສາມາດຕີດຕໍ່support: 4B</p>
      </div>
    :(
    )} */}
      <Container
        style={{
          // ຕອນຈ່າຍແລ້ວເຄີຍປ່ຽນເປັນພື້ນ gradient ມ່ວງ — ມັນໂຜ່ເປັນແຖບຢູ່ຊ່ອງຫວ່າງລະຫວ່າງ card
          // ແລະ ບໍ່ມີບ່ອນອື່ນໃນ flow ໃຊ້ສີນີ້ ສະຖານະຈ່າຍແລ້ວບອກດ້ວຍ banner ຂຽວພຽງພໍແລ້ວ
          background: "transparent",
          padding: 0,
          maxWidth: "100%",
          // ໃຫ້ card ແຕ່ລະອັນມີຈັງຫວະຫ່າງເທົ່າກັນ ແທນການໄປໃສ່ margin ເທື່ອລະບ່ອນ
          display: "flex",
          flexDirection: "column",
          gap: 12,
        }}
      >
        {!orderData?.isPaymented && (
          <div className="cf-card">
            <div className="cf-shop__head">
              <img
                className="cf-shop__avatar"
                src={imageRender(orderData?.shop?.image)}
                alt=""
              />
              <div className="cf-shop__identity">
                <div className="cf-shop__name">{orderData?.shop?.name}</div>
                {(orderData?.live?.pageName ?? orderData?.post?.pageName) && (
                  <div className="cf-shop__page">
                    <FaFacebook aria-hidden="true" />
                    <span>
                      {orderData?.live?.pageName ?? orderData?.post?.pageName}
                    </span>
                  </div>
                )}
              </div>
            </div>

            <div className="cf-shop__contact">
              {orderData?.shop?.phone && (
                <div className="cf-shop__row">
                  <FaPhoneAlt className="cf-shop__icon" aria-hidden="true" />
                  <span>{orderData?.shop?.phone}</span>
                </div>
              )}
              <div className="cf-shop__row">
                <FaMapMarkerAlt className="cf-shop__icon" aria-hidden="true" />
                <span>
                  {[
                    orderData?.shop?.address?.village,
                    orderData?.shop?.address?.district,
                    orderData?.shop?.address?.province,
                  ]
                    .filter(Boolean)
                    .join(", ")}
                </span>
              </div>
            </div>
          </div>
        )}

        {/* ບໍ່ມີ card ເລືອກຂົນສົ່ງຢູ່ໜ້ານີ້ແລ້ວ — ຂົນສົ່ງມາພ້ອມທີ່ຢູ່ທີ່ລູກຄ້າເລືອກ
            ຄົນທີ່ຍັງບໍ່ມີທີ່ຢູ່ຈຶ່ງຄ່ອຍເລືອກຂົນສົ່ງໃນໜ້າ "ເພີ່ມທີ່ຢູ່ຂົນສົ່ງ" */}

        {orderData?.isPaymented ? (
          <FinishOrder
            orderData={orderData}
            taxPrice={taxPrice ?? null}
            shopRate={shopRate}
          />
        ) : (
          // <ConfirmPaymentAuto orderData={orderData} shopRate={shopRate} taxPrice={taxPrice} />
          <div style={{ width: "100%" }}>
            {settingData?.settingByShopId?.isPaymentGateway ? (
              <>
                {!orderData?.isPaymented ? (
                  <>
                    {/* //! FIND ADDRESS BY PHONE */}
                    {isUseLogicstics === "IS_USE_LOGICSTIC" && (
                      <FindAddressByPhone
                        defaultPhone={orderData?.phone}
                        onFound={onFoundAddressByPhone}
                      />
                    )}

                    {/* ບໍ່ໃສ່ພື້ນຂາວ — cf-empty/cf-addr ເປັນ card ຂອງມັນເອງຢູ່ແລ້ວ
                        ຖ້າມີແຖບຂາວຊ້ອນຫຼັງອີກຊັ້ນ ຈະເຫັນເປັນກ່ອງຊ້ອນກ່ອງ ຄືກັບ flow ອື່ນທີ່ບໍ່ມີ */}
                    <div style={{ padding: "4px 0" }}>
                      {isAlert && (
                        <Alert
                          variant="danger"
                          onClick={() => setIsAlert(false)}
                          dismissible
                        >
                          ກາລຸນາປ້ອນ ເບີໂທ ແລະ ທີ່ຢູ່ປາຍທາງ ໃຫ້ຄົບຖ້ວນ!
                        </Alert>
                      )}

                      {/* //! RECEIVE ADDRESS */}
                      {/* <div style={{ fontWeight: "bold", width: "100%", textAlign: "left" }}>
                        ຂົນສົ່ງ
                      </div> */}

                      {isUseLogicstics === "IS_USE_LOGICSTIC" ? (
                        <>
                          {!_.isEmpty(phoneAddresses) ? (
                            <ReceiveDeliveryAddress
                              userAddress={phoneAddresses}
                              setIsReceiveData={setIsReceiveData}
                              userConfirm={
                                !_.isEmpty(idDataUserConfirm)
                                  ? idDataUserConfirm
                                  : null
                              }
                              psid={orderData?.userFbId}
                              orderGroup={orderData}
                              selectedDelivery={selectedDelivery}
                              onUseManualAddress={onUseManualAddress}
                            />
                          ) : (
                            // ຍັງບໍ່ມີທີ່ຢູ່ — pattern ດຽວກັບ ShopInfoOrderConfirm
                            // (ເມື່ອກ່ອນເປັນປຸ່ມແດງໃນກ່ອງຂອບເທົາ + popup ນ້ອຍ ຄົນລະໜ້າຕາກັບ flow ອື່ນ)
                            <div className="cf-empty">
                              <FaMapMarkerAlt
                                className="cf-empty__icon"
                                aria-hidden="true"
                              />
                              <div className="cf-empty__title">
                                ຍັງບໍ່ມີທີ່ຢູ່ຂົນສົ່ງ
                              </div>
                              <div className="cf-empty__text">
                                ເພີ່ມທີ່ຢູ່ເພື່ອໃຫ້ຮ້ານຈັດສົ່ງເຄື່ອງໃຫ້ທ່ານ
                              </div>
                              <button
                                type="button"
                                className="cf-btn cf-btn--primary"
                                disabled={lookupPhone?.length !== 8}
                                onClick={onOpenAddAddress}
                              >
                                + ເພີ່ມທີ່ຢູ່ຂົນສົ່ງ
                              </button>
                              {/* ບອກເຫດຜົນທີ່ປຸ່ມກົດບໍ່ໄດ້ — ບໍ່ງັ້ນລູກຄ້າຈະງົງວ່າເປັນຫຍັງກົດບໍ່ໄດ້ */}
                              {lookupPhone?.length !== 8 && (
                                <div
                                  className="cf-empty__text"
                                  style={{ color: "#d92020" }}
                                >
                                  ປ້ອນເບີໂທຜູ້ຮັບ 8 ຕົວເລກດ້ານເທິງກ່ອນ
                                </div>
                              )}
                            </div>
                          )}

                          {/* ທາງອອກສຳລັບເຈົ້າທີ່ບໍ່ໄດ້ເຊື່ອມກັບລະບົບ — ຄືກັບ ShopInfoOrderConfirm */}
                          <button
                            type="button"
                            className="cf-link-btn"
                            onClick={onUseManualAddress}
                          >
                            ບໍ່ໃຊ້ຂົນສົ່ງໃນລະບົບ? ພິມທີ່ຢູ່ເອງ
                          </button>

                          {/* ໜ້າເຕັມຈໍແບບດຽວກັບ flow ອື່ນ — ຟອມມີ 7 ຊ່ອງ popup ນ້ອຍບໍ່ພໍ */}
                          <AddressSheet
                            open={isAddModal}
                            title="ເພີ່ມທີ່ຢູ່ຂົນສົ່ງ"
                            onClose={onCloseModalAdd}
                          >
                            <div className="cf-card">
                              <FormReceiveAddress
                                userConfirm={
                                  !_.isEmpty(idDataUserConfirm)
                                    ? idDataUserConfirm
                                    : null
                                }
                                psid={orderData?.userFbId}
                                onCloseModalAdd={onCloseModalAdd}
                                fetchUserAddressData={refetchAddressByPhone}
                                orderData={orderData}
                                selectedDelivery={selectedDelivery}
                                // ສະວິດຂົນສົ່ງຂອງຮ້ານ — ຟອມຕ້ອງບໍ່ສະເໜີເຈົ້າທີ່ຮ້ານປິດໄວ້
                                settingByShop={settingData?.settingByShopId}
                                onUseManualAddress={onUseManualAddress}
                              />
                            </div>
                          </AddressSheet>
                        </>
                      ) : (
                        // ໂໝດພິມທີ່ຢູ່ເອງ — pattern ດຽວກັບ ShopInfoOrderConfirm
                        // (ເມື່ອກ່ອນເປັນ Form ຂອງ bootstrap ຄົນລະໜ້າຕາກັບ flow ອື່ນ)
                        <div className="cf-form">
                          {/* ຫົວຟອມ: ຊ້າຍບອກວ່າຢູ່ໂໝດພິມເອງ ຂວາເປັນທາງກັບ
                              ບໍ່ດັ່ງນັ້ນລູກຄ້າຈະຕິດຢູ່ໂໝດນີ້ ບໍ່ມີທາງກັບ */}
                          <div className="cf-form__switch">
                            <div className="cf-form__mode">ພິມທີ່ຢູ່ເອງ</div>
                            {settingData?.settingByShopId?.isUseLogistics && (
                              <button
                                type="button"
                                className="cf-link-btn cf-link-btn--sm"
                                onClick={() =>
                                  setIsUseLogicstics("IS_USE_LOGICSTIC")
                                }
                              >
                                ໃຊ້ຂົນສົ່ງໃນລະບົບ
                              </button>
                            )}
                          </div>
                          {isAlert && (
                            <div
                              className="cf-alert"
                              onClick={() => setIsAlert(false)}
                              role="alert"
                            >
                              ກາລຸນາປ້ອນ ເບີໂທ ແລະ ທີ່ຢູ່ປາຍທາງ ໃຫ້ຄົບຖ້ວນ!
                            </div>
                          )}
                          <div className="cf-field">
                            {" "}
                            {/* NAME */}
                            <label
                              className="cf-field__label"
                              htmlFor="cf-customerName"
                            >
                              ຊື່ລູກຄ້າ{" "}
                              <span className="cf-field__required">*</span>
                            </label>
                            <input
                              id="cf-customerName"
                              className="cf-input"
                              value={customerName}
                              onChange={(e) =>
                                setCustomerName(e?.target?.value)
                              }
                              type="text"
                              autoComplete="name"
                            />
                          </div>

                          <div className="cf-field">
                            {" "}
                            {/* PHONE */}
                            <label
                              className="cf-field__label"
                              htmlFor="cf-customerPhone"
                            >
                              ເບີໂທ{" "}
                              <span className="cf-field__required">*</span>
                            </label>
                            <div className="cf-field__control">
                              <input
                                id="cf-customerPhone"
                                // ຍັງບໍ່ໄດ້ປ້ອນ: ຂອບແດງກະພິບ — ພໍເລີ່ມພິມ ສະຖານະ valid/invalid ເດີມຮັບຕໍ່
                                className={`cf-input${isPhoneValid ? " cf-input--valid" : ""}${isPhoneInvalid ? " cf-input--invalid" : ""}${!phone ? " cf-input--attention" : ""}`}
                                value={phone}
                                autoComplete="tel"
                                onChange={(e) => {
                                  const input = e.target.value;
                                  // Only allow numbers and limit to 11 characters
                                  const numericInput = input.replace(/\D/g, "");
                                  if (numericInput.length < 12) {
                                    setPhone(numericInput);
                                  }
                                }}
                                type="tel"
                                inputMode="numeric"
                                placeholder="020 XXX-XXX-XX"
                                maxLength={11}
                              />
                              {isPhoneValid && (
                                <span
                                  className="cf-field__valid-icon"
                                  aria-hidden="true"
                                >
                                  <FaCheckCircle />
                                </span>
                              )}
                            </div>
                            {isPhoneInvalid && (
                              <div className="cf-field__error">
                                {phone.length < 7
                                  ? "ເບີໂທຕ້ອງມີຢ່າງໜ້ອຍ 7 ໂຕເລກ"
                                  : "ເບີໂທຕ້ອງບໍ່ເກີນ 11 ໂຕເລກ"}
                              </div>
                            )}
                            <div className="cf-field__helper">
                              ປ້ອນເບີໂທ 8 ໂຕເລກ (ບໍ່ຈຳເປັນຕ້ອງໃສ່ 20, 020, 030,
                              ຫຼື 856)
                            </div>
                          </div>

                          <div className="cf-field">
                            {" "}
                            {/* ADDRESS */}
                            <label
                              className="cf-field__label"
                              htmlFor="cf-deliveryAddress"
                            >
                              ທີ່ຢູ່ຂົນສົ່ງ ພິມຊື່ຂົນສົ່ງ ສາຂາ ໃຫ້ລະອຽດ{" "}
                              <span className="cf-field__required">*</span>
                            </label>
                            <textarea
                              id="cf-deliveryAddress"
                              // ຂອບແດງກະພິບຈົນກວ່າຈະປ້ອນທີ່ຢູ່
                              className={`cf-input cf-textarea${String(address ?? "").trim() ? "" : " cf-input--attention"}`}
                              value={address}
                              onChange={(e) => setAddress(e?.target?.value)}
                              rows={2}
                              placeholder="ປ້ອນທີ່ຢູ່ລະອຽດ ຫຼື ສາຂາຂົນສົ່ງ..."
                            />
                          </div>
                        </div>
                      )}
                    </div>
                  </>
                ) : (
                  <p
                    style={{
                      width: "100%",
                      textAlign: "center",
                      color: "green",
                      fontSize: 28,
                    }}
                  >
                    ຈ່າຍເງິນແລ້ວ
                  </p>
                )}
              </>
            ) : (
              <ShopInfoOrderConfirm
                setSecondStep={setSecondStep}
                setLastStep={setLastStep}
                orderData={orderData}
                shopSettingData={shopSettingData}
                getLiveOrder={getLiveOrder}
                isUseLogicstics={isUseLogicstics}
                setIsUseLogicstics={setIsUseLogicstics}
                selectedDelivery={selectedDelivery}
                isAlert={isAlert}
                setIsAlert={setIsAlert}
                setIsShipMentPayType={setIsShipMentPayType}
                isShipMentPayType={isShipMentPaytype}
                settingDataByShop={settingData}
                shopRate={shopRate}
                taxPrice={taxPrice ?? null}
              />
            )}

            <OrderGroupDetail
              orderData={orderData}
              taxPrice={taxPrice ?? null}
              shopRate={shopRate}
              setSecondStep={setSecondStep}
              isPaymented={orderData?.isPaymented}
            />

            {/* ຍອດເງິນຕິດຢູ່ລຸ່ມຕະຫຼອດ — pattern ດຽວກັບ ShopInfoOrderConfirm
                (.cf-page ເວັ້ນ padding ລຸ່ມໄວ້ໃຫ້ແຖບນີ້ແລ້ວ) */}
            {!orderData?.isPaymented &&
              settingData?.settingByShopId?.isPaymentGateway &&
              paymentSupports?.partner !== null && (
                <div className="cf-bottombar">
                  <div className="cf-bottombar__total">
                    <span className="cf-bottombar__label">ຍອດຕ້ອງຊຳລະ</span>
                    <span className="cf-bottombar__amount">
                      {numberFormat(
                        calcOrderTotal({ orderData, taxPrice, shopRate }),
                      )}
                      ₭
                    </span>
                  </div>
                  <button
                    type="button"
                    className="cf-btn cf-btn--primary"
                    disabled={loadingConfirmOrder ? true : false}
                    onClick={onConfirmForClient}
                  >
                    {loadingConfirmOrder && (
                      <Spinner size="sm" animation="border" />
                    )}{" "}
                    ຂໍ QR ຊຳລະເງີນ
                  </button>
                </div>
              )}
          </div>
        )}

        <Modal
          size="lg"
          centered
          show={showPreview}
          onHide={() => setShowPreview(false)}
        >
          <Modal.Body
            style={{
              width: "100%",
              height: "85vh",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              flexDirection: "column",
              position: "relative",
            }}
          >
            <iframe
              src={qrCodeUrl}
              title="description"
              style={{ width: "100%", height: "100%" }}
            ></iframe>
            {/* <img style={{   width: 140, objectFit: 'contain', }} src="https://us.123rf.com/450wm/asagraphia/asagraphia2212/asagraphia221200361/195674474-flat-isometric-3d-illustration-online-payment-security.jpg?ver=6" />
            <h4>ທ່ານກຳລັງພະຍາຍາມຊຳລະເງິນຢູ່</h4>
            <Button onClick={() => setShowPreview(false)} style={{background: BG_GRADIENT_NEW, color: COLOR_WHITE, border:'none'}} >
                <MdClose style={{ fontSize: 18 }} /> ປິດໜ້ານີ້
              </Button> */}
          </Modal.Body>
        </Modal>

        {/*  confirm COD for customer */}
        <ConfirmCOD
          isShipMentPaytype={isShipMentPaytype}
          setIsShipMentPayType={setIsShipMentPayType}
          handleCloseCodModal={handleCloseCodModal}
        />
      </Container>
    </>
  );
}

export default MultiStepForm;
